export enum ChatType {
    Container = "CONTAINER",
    Memo = "MEMO",
}
